import { render, staticRenderFns } from "./informacion.vue?vue&type=template&id=f5b72492&scoped=true&"
import script from "./informacion.vue?vue&type=script&lang=js&"
export * from "./informacion.vue?vue&type=script&lang=js&"
import style0 from "./informacion.vue?vue&type=style&index=0&id=f5b72492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b72492",
  null
  
)

export default component.exports